import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "antd";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../components/styled-antd";
import { PATH, eContentFields } from "../constant";
import { RenderHelper } from "../../summary-employee-request/utils/render-helper";
import { PlusCircleOutlined } from "@ant-design/icons";
import { getPage } from "../utils/get-page";
import { useRouteMatch } from "react-router-dom";
import _ from "lodash";

export const AddTable = ({ dataSource, setDataSource, indexParent }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const routeMatch = useRouteMatch();

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();

    setIsModalOpen(true);
  };

  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = _.clone(dataSource);
    newDataSource[indexParent].data.push({ ...values });

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <div style={{ marginTop: -40,  }}>
        <div className="d-flex">
          <StyledTitle level={5}>
            Tổng cộng: {dataSource[indexParent].data.length}
          </StyledTitle>

          {getPage(routeMatch) !== PATH.HOME && (
            <Button onClick={showModal} className="mb-3 ml-3">
              <div className="mb-1">
                <PlusCircleOutlined rev="data" />
              </div>
            </Button>
          )}
        </div>
      </div>

      <Modal
        title="NHÂN SỰ ĐƯỢC THAY ĐỔI/BỔ SUNG KHÓA HỌC"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <RenderHelper fields={eContentFields} />

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
